/**
 * @module learningTags
 */
import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { learningContentActions } from '~/behaviors/actions/learning_content.actions';

const defaultState = {};

const reset = () => defaultState;

const merge = (state, action) => {
  const learningTags = action?.payload?.entities?.learningTags ?? [];

  Object.values(learningTags).forEach((type) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[type.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[type.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...type,
    };
  });
};

const learningTags = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(learningContentActions.fetchLearningTags.fulfilled, merge);
});

export default learningTags;
